// extracted by mini-css-extract-plugin
export default {"cell":"AddressCell_cell__vv4v2","name":"AddressCell_name__Jo1UW","address":"AddressCell_address__J2kF8"};